import { AlertDataI, AlertService2 } from '../services/alert2.service';

export class Alert {
  private static service: AlertService2;

  static registerService(service: AlertService2) {
    this.service = service;
  }

  static show(data: AlertDataI) {
    if (!this.service) {
      console.error('CustomAlert service not registered!');
      return;
    }
    this.service.showAlert(data);
  }

  static modal(data: AlertDataI) {
    Alert.show({ ...data, view: 'modal' });
  }
}
